import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { url } from "../link";
import logo from "../components/logo512.jpg";
import Loading from "../components/Loading";

const Login = () => {
  const nav = useNavigate();
  const [x, setx] = useState(0);
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");

  const submitdata = () => {
    setx(1);
    const value = { email, password };

    axios
      .post(url + "/edusphere/login", value)
      .then((response) => {
        if (response.data.length === 1) {
          window.localStorage.setItem("user", response.data[0]);
          window.localStorage.setItem("name", response.data[1]);
          nav("/enquiryentry");
        } else {
          alert("Email or password wrong");
          setx(0);
        }
      })
      .catch(() => setx(0));
  };

  useEffect(() => {
    if (window.localStorage.getItem("user") !== null) {
      nav("/dashboard");
    }
  });

  if (x === 1) return <Loading />;

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div
        className="card shadow-lg border-0 rounded-4 p-4"
        style={{ maxWidth: "400px", width: "100%" }}
      >
        <div className="text-center mb-4">
          <img
            src={logo}
            alt="Logo"
            className="rounded-circle mb-3"
            width="80"
            height="80"
          />
          <h3 className="fw-bold text-primary">Office Login</h3>
          <p className="text-muted small">Welcome back! Please sign in.</p>
        </div>

        <div className="form-floating mb-3">
          <input
            type="email"
            className="form-control"
            id="email"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setemail(e.target.value)}
          />
          <label htmlFor="email">Email address</label>
        </div>

        <div className="form-floating mb-3">
          <input
            type="password"
            className="form-control"
            id="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setpassword(e.target.value)}
          />
          <label htmlFor="password">Password</label>
        </div>

        <button
          className="btn btn-primary w-100 py-2 fw-bold"
          onClick={submitdata}
        >
          Sign In
        </button>

        <div className="text-center mt-3">
          <a href="#" className="text-decoration-none small text-muted">
            Forgot Password?
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
